import template from "./clients.html";
import controller from "./clients.controller";

const ConfigurationsComponent = {
    template,
    controller,
    controllerAs: "controller"
};

export default ConfigurationsComponent;


// WEBPACK FOOTER //
// ./sources/components/clients/clients-component.js